import { TeCommonApiUrl } from '@/config';
import ajaxService from './ajaxService';

const defaultBaseURL = TeCommonApiUrl;

export default {
  // 取得 CN 地區資料
  getCNZipData(param) {
    return ajaxService.get('/api/CNZipData', param, {}, { baseURL: defaultBaseURL });
  },
};
